export default class DynamicSelect {
  els = {
    select: '[data-dynamic-select-params]'
  }

  constructor () {
    this.bindEvents()
  }

  /**
   * @param target {HTMLElement}
   * */

   sendRequest({target}) {
    let targetData = target.dataset.dynamicSelectParams,
      selectData = {};

    if (!targetData) {
      return false
    }

    this.setSelectParams(target)

    console.debug('dynamicSelectAjaxData:', this.getSelectParams(target))

    // $.ajax({
    //   method: "POST",
    //   url: "./ajax/dynamicSelect.json",
    //   data: this.getSelectParams(target)
    // })
  }

  /**
   * @param select {HTMLElement}
   * @return {Object}
   * */

  getSelectParams(select) {
    return  select.dataset.dynamicSelectParams;
  }

  /**
   * @param select {HTMLElement}
   * */

  setSelectParams(select) {
    let selectData = JSON.parse(select.dataset.dynamicSelectParams),
      newSelectData = {
        ...selectData,
        value: select.value
      };

    select.dataset.dynamicSelectParams = JSON.stringify(newSelectData)
  }

  bindEvents () {
    if (document.querySelector(this.els.select)) {
      document.querySelectorAll(this.els.select).forEach(node => {
        node.addEventListener('change', (e)=> this.sendRequest(e))
      })
    }
  }
}